import { Box, Icons, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';
import type { Post } from '@core/types/state';
import { createStyles } from './PinnedPosts.styles';
import SidebarPinnedPost from './PinnedPost';

type Props = {
  pinnedPosts: Post[];
};

const SidebarPinnedPosts = ({ pinnedPosts }: Props) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Box sx={styles.headerContent}>
          <Icons.PushPinOutlined sx={styles.headerIcon} />
          <Box>All Pinned post ({pinnedPosts.length})</Box>
        </Box>
      </Box>
      <Box
        sx={styles.list}
        tabIndex={0}
        role="region"
        aria-label="Pinned posts"
      >
        {pinnedPosts.map((pinnedPost) => (
          <SidebarPinnedPost key={pinnedPost.objectId} post={pinnedPost} />
        ))}
      </Box>
    </Box>
  );
};

export default SidebarPinnedPosts;
